import { Component, OnDestroy, Host, ChangeDetectorRef, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MatCalendar } from '@angular/material/datepicker';
import { Subject } from 'rxjs';
import { DateAdapter, MAT_DATE_FORMATS, MatDateFormats } from '@angular/material';
import { takeUntil } from 'rxjs/operators';
import { AppConfigEnvironmentService } from '@shared/service/appconfig-environment.service';

/** Custom header component for datepicker. */
@Component({
    selector: 'calendar-header',
    templateUrl: './calendar-header.component.html',
    styleUrls: ['./calendar-header.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CalendarHeaderComponent<D> implements OnDestroy {
    
    private destroyed = new Subject<void>();

    constructor(
        @Host() private calendar: MatCalendar<D>,
        private dateAdapter: DateAdapter<D>,
		private appConfig: AppConfigEnvironmentService,
        @Inject(MAT_DATE_FORMATS) private dateFormats: MatDateFormats,
        cdr: ChangeDetectorRef
    ) {
        calendar.stateChanges
            .pipe(takeUntil(this.destroyed))
            .subscribe(() => cdr.markForCheck());
            
        this.dateAdapter.setLocale(appConfig.Environment.SERVER_DATE_LOCATION);
    }

    ngOnDestroy() {
        this.destroyed.next();
        this.destroyed.complete();
    }

    get periodLabel() {
        return this.dateAdapter
            .format(this.calendar.activeDate, this.dateFormats.display.dateA11yLabel)
            .toLocaleUpperCase();
    }

    previousClicked(mode: 'month' | 'year') {
        this.calendar.activeDate = mode === 'month' ?
            this.dateAdapter.addCalendarMonths(this.calendar.activeDate, -1) :
            this.dateAdapter.addCalendarYears(this.calendar.activeDate, -1);
    }

    nextClicked(mode: 'month' | 'year') {
        this.calendar.activeDate = mode === 'month' ?
            this.dateAdapter.addCalendarMonths(this.calendar.activeDate, 1) :
            this.dateAdapter.addCalendarYears(this.calendar.activeDate, 1);
    }
}